import React, { useEffect } from "react";
import "./Pyment.css";

// Cash payment option is disabled — go straight to online payment.
const PaymentOptionModal = ({ open, onClose, onSelect }) => {
  useEffect(() => {
    if (open) {
      onSelect("online");
    }
  }, [open, onSelect]);

  return null;
};

export default PaymentOptionModal;
